import IndexRoutes from './Routes/Index';

function App() {
  return (
    <IndexRoutes/>
  );
}

export default App;